// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vert-template-marketplace.vert-notifications {
  display: flex;
  flex-direction: column;
  position: relative;
}
.vert-template-marketplace.vert-notifications .vert-notification-icon {
  display: flex;
  flex-direction: column;
  color: var(--color-neutral-dark);
}
.vert-template-marketplace.vert-notifications .vert-notification-icon .vert-notification-badge {
  position: absolute;
  z-index: 1;
  margin-top: -5px;
  margin-left: 12px;
  cursor: pointer;
}
.vert-template-marketplace.vert-notifications .vert-notification-icon .vert-notification-badge .notification-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: var(--font-family);
  font-size: 8px;
  color: var(--color-white);
  background-color: var(--color-error);
  border-radius: 50%;
  width: 12px;
  height: 12px;
  padding: 2px;
}
.vert-template-marketplace.vert-notifications .vert-notification-icon .vert-icon {
  cursor: pointer;
}
.vert-template-marketplace.vert-notifications .vert-notification-icon .vert-icon svg {
  transition: fill 0.2s ease-in-out;
}
.vert-template-marketplace.vert-notifications .vert-notification-icon .vert-icon.has-notification svg {
  fill: var(--color-detached);
}
.vert-template-marketplace.vert-notifications .vert-notification-icon:hover .vert-icon svg {
  fill: var(--color-detached);
}
.vert-template-marketplace.vert-notifications .vert-notification-icon.active .vert-icon svg {
  fill: var(--color-detached);
}
.vert-template-marketplace.vert-notifications .vert-notifications-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  box-shadow: 0px 5px 15px 7px rgba(0, 0, 0, 0.1);
  background-color: var(--color-white);
  z-index: 99;
  border-radius: 8px;
  padding: 16px 20px;
  width: 331px;
  top: 41px;
}
.vert-template-marketplace.vert-notifications .vert-notifications-wrapper .vert-notifications-triangle {
  position: absolute;
  width: 0;
  background-color: transparent;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid var(--color-white);
  box-shadow: 0px -5px 15px 7px rgba(0, 0, 0, 0.1);
  top: -10px;
  right: 0;
  transform: translateX(-50%);
}
.vert-template-marketplace.vert-notifications .vert-notifications-wrapper .vert-notification-close-icon {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: row;
  font-size: var(--font-paragraph);
  color: var(--color-neutral-dark);
  width: 100%;
}
.vert-template-marketplace.vert-notifications .vert-notifications-wrapper .vert-notifications-content {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.vert-template-marketplace.vert-notifications .vert-notifications-wrapper .vert-notifications-content + .vert-notifications-content::before {
  content: '';
  width: 100%;
  height: 1px;
  background-color: var(--color-border) !important;
  margin: 10px 0px;
}
.vert-template-marketplace.vert-notifications .vert-notifications-wrapper .vert-notifications-content p {
  line-height: var(--font-paragraph-line);
  margin: 0;
}
.vert-template-marketplace.vert-notifications .vert-notifications-wrapper .vert-notifications-content .vert-notification-date {
  color: var(--color-neutral-dark-lighter);
  font-family: var(--font-family);
  font-size: 16px !important;
  margin-bottom: var(--spacing-extra-small);
}
.vert-template-marketplace.vert-notifications .vert-notifications-wrapper .vert-notifications-content .vert-notification-content-box {
  display: flex;
  align-items: center;
  gap: 10px;
}
.vert-template-marketplace.vert-notifications .vert-notifications-wrapper .vert-notifications-content .vert-notification-content-box .vert-notification-icon-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  padding: var(--spacing-extra-small);
  border-radius: 50%;
  background-color: var(--color-neutral-light-lighter);
  color: var(--color-detached-lighter);
  font-size: 16px;
  font-weight: bold;
}
.vert-template-marketplace.vert-notifications .vert-notifications-wrapper .vert-notifications-content .vert-notification-content-box .vert-notification-title {
  font-family: var(--font-family);
  font-size: 14px;
  color: var(--color-neutral-dark);
  font-weight: bold;
}
.vert-template-marketplace.vert-notifications .vert-notifications-wrapper .vert-notifications-content .vert-notification-content-footer {
  display: flex;
  flex-direction: column;
  margin-left: var(--spacing-small);
}
.vert-template-marketplace.vert-notifications .vert-notifications-wrapper .vert-notifications-content .vert-notification-content-footer .vert-notification-description {
  font-family: var(--font-family);
  font-size: 14px;
  color: var(--color-neutral-dark-lighter);
}
.notifications-mobile-modal-spot {
  height: 50vh;
  max-width: 100%;
  border-radius: 8px;
}
.notifications-mobile-modal-spot .ant-modal-content {
  display: flex;
  justify-content: center;
  height: 100%;
  width: 350px;
  margin: 0 auto;
  border-radius: var(--border-radius-secondary) !important;
  bottom: 0px;
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-close {
  line-height: 0;
  margin: 0;
  width: 0;
  height: 0;
  padding: var(--button-padding-extra-sm);
  color: var(--color-neutral-dark) !important;
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-close:hover {
  background: transparent;
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-close .ant-modal-close-x {
  padding: 0;
  line-height: 0;
  margin: 0;
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-close .ant-modal-close-x svg {
  width: 14px;
  height: 14px;
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-body {
  margin-top: var(--spacing-regular);
  width: 100%;
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-body .vert-notifications-wrapper {
  display: flex;
  flex-direction: column;
  padding: 8px;
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-body .vert-notifications-wrapper .vert-notifications-content {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-body .vert-notifications-wrapper .vert-notifications-content + .vert-notifications-content::before {
  content: '';
  width: 100%;
  height: 1px;
  background-color: var(--color-border) !important;
  margin: 10px 0px;
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-body .vert-notifications-wrapper .vert-notifications-content p {
  line-height: var(--font-paragraph-line);
  margin: 0;
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-body .vert-notifications-wrapper .vert-notifications-content .vert-notification-date {
  color: var(--color-neutral-dark-lighter);
  font-family: var(--font-family);
  font-size: 16px !important;
  margin-bottom: var(--spacing-extra-small);
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-body .vert-notifications-wrapper .vert-notifications-content .vert-notification-content-box {
  display: flex;
  align-items: center;
  gap: 10px;
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-body .vert-notifications-wrapper .vert-notifications-content .vert-notification-content-box .vert-notification-icon-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  padding: var(--spacing-extra-small);
  border-radius: 50%;
  background-color: var(--color-neutral-light-lighter);
  color: var(--color-detached-lighter);
  font-size: 16px;
  font-weight: bold;
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-body .vert-notifications-wrapper .vert-notifications-content .vert-notification-content-box .vert-notification-title {
  font-family: var(--font-family);
  font-size: 14px;
  color: var(--color-neutral-dark);
  font-weight: bold;
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-body .vert-notifications-wrapper .vert-notifications-content .vert-notification-content-footer {
  display: flex;
  flex-direction: column;
  margin-left: var(--spacing-small);
}
.notifications-mobile-modal-spot .ant-modal-content .ant-modal-body .vert-notifications-wrapper .vert-notifications-content .vert-notification-content-footer .vert-notification-description {
  font-family: var(--font-family);
  font-size: 14px;
  color: var(--color-neutral-dark-lighter);
}
.vert-notification-href {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  cursor: pointer;
  color: var(--color-detached-lighter) !important;
  font-size: var(--font-paragraph);
  font-family: var(--font-family);
  text-decoration: none;
  font-weight: 500;
  line-height: var(--font-paragraph-line);
  margin-top: var(--spacing-small);
  transition: color 0.2s ease-in-out;
  text-decoration: none !important;
}
.vert-notification-href:hover {
  color: var(--color-neutral-darker);
  filter: brightness(0.8);
}
.vert-notification-empty {
  font-family: var(--font-family);
  font-size: var(--font-paragraph);
  color: var(--color-neutral-dark-lighter);
  margin-top: var(--spacing-small);
  line-height: var(--font-paragraph-line);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/VertNotification/VertNotifications.less"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AAAJ;AAHE;EAOI,aAAA;EACA,sBAAA;EACA,gCAAA;AADN;AARE;EAYM,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AADR;AAfE;EAmBQ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EAEA,+BAAA;EACA,cAAA;EACA,yBAAA;EACA,oCAAA;EAEA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAHV;AA7BE;EAqCM,eAAA;AALR;AAhCE;EAuCQ,iCAAA;AAJV;AAMQ;EAEI,2BAAA;AALZ;AASM;EAGM,2BAAA;AATZ;AAaM;EAGM,2BAAA;AAbZ;AA5CE;EAiEI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,+CAAA;EACA,oCAAA;EAEA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;AApBN;AAzDE;EAgFM,kBAAA;EACA,QAAA;EACA,6BAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,4CAAA;EACA,gDAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AApBR;AAtEE;EA8FM,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gCAAA;EACA,WAAA;AArBR;AA/EE;EAwGM,aAAA;EACA,sBAAA;EACA,QAAA;AAtBR;AAyBU;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,gDAAA;EACA,gBAAA;AAvBZ;AA3FE;EAuHQ,uCAAA;EACA,SAAA;AAzBV;AA/FE;EA4HQ,wCAAA;EACA,+BAAA;EACA,0BAAA;EACA,yCAAA;AA1BV;AArGE;EAmIQ,aAAA;EACA,mBAAA;EACA,SAAA;AA3BV;AA1GE;EAwIU,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,oDAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;AA3BZ;AAvHE;EAsJU,+BAAA;EACA,eAAA;EACA,gCAAA;EACA,iBAAA;AA5BZ;AA7HE;EA6JQ,aAAA;EACA,sBAAA;EACA,iCAAA;AA7BV;AAlIE;EAiKU,+BAAA;EACA,eAAA;EACA,wCAAA;AA5BZ;AAoCA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AAlCF;AA+BA;EAMI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EAEA,wDAAA;EACA,WAAA;AAnCJ;AAsBA;EAgBM,cAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,uCAAA;EACA,2CAAA;AAnCN;AAqCM;EACE,uBAAA;AAnCR;AAWA;EA4BQ,UAAA;EACA,cAAA;EACA,SAAA;AApCR;AAMA;EAiCU,WAAA;EACA,YAAA;AApCV;AAEA;EAwCM,kCAAA;EACA,WAAA;AAvCN;AAFA;EA4CQ,aAAA;EACA,sBAAA;EACA,YAAA;AAvCR;AAPA;EAiDU,aAAA;EACA,sBAAA;EACA,QAAA;AAvCV;AA0CY;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,gDAAA;EACA,gBAAA;AAxCd;AAnBA;EAgEY,uCAAA;EACA,SAAA;AA1CZ;AAvBA;EAqEY,wCAAA;EACA,+BAAA;EACA,0BAAA;EACA,yCAAA;AA3CZ;AA7BA;EA4EY,aAAA;EACA,mBAAA;EACA,SAAA;AA5CZ;AAlCA;EAiFc,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,oDAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;AA5Cd;AA/CA;EA+Fc,+BAAA;EACA,eAAA;EACA,gCAAA;EACA,iBAAA;AA7Cd;AArDA;EAuGY,aAAA;EACA,sBAAA;EACA,iCAAA;AA/CZ;AA1DA;EA2Gc,+BAAA;EACA,eAAA;EACA,wCAAA;AA9Cd;AAuDA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,eAAA;EACA,+CAAA;EACA,gCAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uCAAA;EACA,gCAAA;EACA,kCAAA;EACA,gCAAA;AArDF;AAuDE;EACE,kCAAA;EACA,uBAAA;AArDJ;AAyDA;EACE,+BAAA;EACA,gCAAA;EACA,wCAAA;EACA,gCAAA;EACA,uCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAvDF","sourcesContent":[".vert-template-marketplace {\n  &.vert-notifications {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n\n    // notification icon\n    .vert-notification-icon {\n      display: flex;\n      flex-direction: column;\n      color: var(--color-neutral-dark);\n\n      .vert-notification-badge {\n        position: absolute;\n        z-index: 1;\n        margin-top: -5px;\n        margin-left: 12px;\n        cursor: pointer;\n\n        .notification-badge {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n\n          font-family: var(--font-family);\n          font-size: 8px;\n          color: var(--color-white);\n          background-color: var(--color-error);\n\n          border-radius: 50%;\n          width: 12px;\n          height: 12px;\n          padding: 2px;\n        }\n      }\n\n      .vert-icon {\n        cursor: pointer;\n        svg {\n          transition: fill 0.2s ease-in-out;\n        }\n        &.has-notification {\n          svg {\n            fill: var(--color-detached);\n          }\n        }\n      }\n      &:hover {\n        .vert-icon {\n          svg {\n            fill: var(--color-detached);\n          }\n        }\n      }\n      &.active {\n        .vert-icon {\n          svg {\n            fill: var(--color-detached);\n          }\n        }\n      }\n    }\n\n    // notification content\n    .vert-notifications-wrapper {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      position: absolute;\n\n      box-shadow: 0px 5px 15px 7px rgba(0, 0, 0, 0.1);\n      background-color: var(--color-white);\n\n      z-index: 99;\n      border-radius: 8px;\n      padding: 16px 20px;\n      width: 331px;\n      top: 41px;\n\n      .vert-notifications-triangle {\n        position: absolute;\n        width: 0;\n        background-color: transparent;\n        height: 0;\n        border-left: 10px solid transparent;\n        border-right: 10px solid transparent;\n        border-bottom: 10px solid var(--color-white);\n        box-shadow: 0px -5px 15px 7px rgba(0, 0, 0, 0.1);\n        top: -10px;\n        right: 0;\n        transform: translateX(-50%);\n      }\n\n      .vert-notification-close-icon {\n        display: flex;\n        justify-content: flex-end;\n        align-items: flex-end;\n        flex-direction: row;\n        font-size: var(--font-paragraph);\n        color: var(--color-neutral-dark);\n        width: 100%;\n      }\n\n      .vert-notifications-content {\n        display: flex;\n        flex-direction: column;\n        gap: 5px;\n\n        & + .vert-notifications-content {\n          &::before {\n            content: '';\n            width: 100%;\n            height: 1px;\n            background-color: var(--color-border) !important;\n            margin: 10px 0px;\n          }\n        }\n\n        p {\n          line-height: var(--font-paragraph-line);\n          margin: 0;\n        }\n\n        .vert-notification-date {\n          color: var(--color-neutral-dark-lighter);\n          font-family: var(--font-family);\n          font-size: 16px !important;\n          margin-bottom: var(--spacing-extra-small);\n        }\n\n        .vert-notification-content-box {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n\n          .vert-notification-icon-item {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            width: 24px;\n            height: 24px;\n            padding: var(--spacing-extra-small);\n            border-radius: 50%;\n            background-color: var(--color-neutral-light-lighter);\n            color: var(--color-detached-lighter);\n            font-size: 16px;\n            font-weight: bold;\n          }\n\n          .vert-notification-title {\n            font-family: var(--font-family);\n            font-size: 14px;\n            color: var(--color-neutral-dark);\n            font-weight: bold;\n          }\n        }\n        .vert-notification-content-footer {\n          display: flex;\n          flex-direction: column;\n          margin-left: var(--spacing-small);\n          .vert-notification-description {\n            font-family: var(--font-family);\n            font-size: 14px;\n            color: var(--color-neutral-dark-lighter);\n          }\n        }\n      }\n    }\n  }\n}\n\n.notifications-mobile-modal-spot {\n  height: 50vh;\n  max-width: 100%;\n  border-radius: 8px;\n\n  .ant-modal-content {\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    width: 350px;\n    margin: 0 auto;\n\n    border-radius: var(--border-radius-secondary) !important;\n    bottom: 0px;\n\n    .ant-modal-close {\n      line-height: 0;\n      margin: 0;\n      width: 0;\n      height: 0;\n      padding: var(--button-padding-extra-sm);\n      color: var(--color-neutral-dark) !important;\n\n      &:hover {\n        background: transparent;\n      }\n\n      .ant-modal-close-x {\n        padding: 0;\n        line-height: 0;\n        margin: 0;\n\n        svg {\n          width: 14px;\n          height: 14px;\n        }\n      }\n    }\n\n    .ant-modal-body {\n      margin-top: var(--spacing-regular);\n      width: 100%;\n\n      .vert-notifications-wrapper {\n        display: flex;\n        flex-direction: column;\n        padding: 8px;\n\n        .vert-notifications-content {\n          display: flex;\n          flex-direction: column;\n          gap: 5px;\n\n          & + .vert-notifications-content {\n            &::before {\n              content: '';\n              width: 100%;\n              height: 1px;\n              background-color: var(--color-border) !important;\n              margin: 10px 0px;\n            }\n          }\n\n          p {\n            line-height: var(--font-paragraph-line);\n            margin: 0;\n          }\n\n          .vert-notification-date {\n            color: var(--color-neutral-dark-lighter);\n            font-family: var(--font-family);\n            font-size: 16px !important;\n            margin-bottom: var(--spacing-extra-small);\n          }\n\n          .vert-notification-content-box {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n\n            .vert-notification-icon-item {\n              display: flex;\n              justify-content: center;\n              align-items: center;\n              width: 24px;\n              height: 24px;\n              padding: var(--spacing-extra-small);\n              border-radius: 50%;\n              background-color: var(--color-neutral-light-lighter);\n              color: var(--color-detached-lighter);\n              font-size: 16px;\n              font-weight: bold;\n            }\n\n            .vert-notification-title {\n              font-family: var(--font-family);\n              font-size: 14px;\n              color: var(--color-neutral-dark);\n              font-weight: bold;\n            }\n          }\n\n          .vert-notification-content-footer {\n            display: flex;\n            flex-direction: column;\n            margin-left: var(--spacing-small);\n            .vert-notification-description {\n              font-family: var(--font-family);\n              font-size: 14px;\n              color: var(--color-neutral-dark-lighter);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.vert-notification-href {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  cursor: pointer;\n  color: var(--color-detached-lighter) !important;\n  font-size: var(--font-paragraph);\n  font-family: var(--font-family);\n  text-decoration: none;\n  font-weight: 500;\n  line-height: var(--font-paragraph-line);\n  margin-top: var(--spacing-small);\n  transition: color 0.2s ease-in-out;\n  text-decoration: none !important;\n\n  &:hover {\n    color: var(--color-neutral-darker);\n    filter: brightness(0.8);\n  }\n}\n\n.vert-notification-empty {\n  font-family: var(--font-family);\n  font-size: var(--font-paragraph);\n  color: var(--color-neutral-dark-lighter);\n  margin-top: var(--spacing-small);\n  line-height: var(--font-paragraph-line);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
